var localForage = require('localforage');
var _ = require('lodash');
export default {
    install: function (Vue) {
        let checksheet = {};
        checksheet.loading = false;  // caricamento dell'oggetto
        checksheet.data = [];        // l'elenco degli elementi
        checksheet.dataOff = []; // l'elenco degli elementi offline
        checksheet.page = 1;         // pagina corrente
        checksheet.isEndList = false;    // indica se sono alla fine della lista
        checksheet.isFirstList = true;   // indica se sono all'inizio della lista
        checksheet.customers = [];
        checksheet.structureDoc = [
            {
                background: 'scheda_controllo',
                show: true,
                positions: [
                    {
                        key: 'contratto',
                        x: 1200,
                        y: 240
                    },
                    {
                        key: 'data_controllo',
                        x: 870,
                        y: 217,
                        class: 'big',
                        type: 'date'
                    },
                    {
                        key: 'customer.agency',
                        x: 250,
                        y: 310
                    },
                    {
                        key: 'customer.address',
                        x: 280,
                        y: 335
                    },
                    {
                        key: 'customer.city',
                        x: 290,
                        y: 355
                    },
                    {
                        key: 'sede.indirizzo',
                        x: 850,
                        y: 325
                    },
                    {
                        key: 'sede.luogo',
                        x: 850,
                        y: 355
                    },
                    {
                        key: 'kg',
                        x: 180,
                        y: 473
                    },
                    {
                        key: 'matricola',
                        x: 430,
                        y: 473
                    },
                    {
                        key: 'scadenza_collaudi',
                        x: 670,
                        y: 473,
                        type: 'date'
                    },
                    {
                        key: 'ubicazione',
                        x: 920,
                        y: 473
                    },
                    {
                        key: 'protezione_macchina',
                        x: 1170,
                        y: 473
                    },
                    {
                        key: 'affilatrice',
                        x: 180,
                        y: 568
                    },
                    {
                        key: 'matricola_2',
                        x: 510,
                        y: 568
                    },
                    {
                        key: 'tipo_centrale',
                        x: 800,
                        y: 568
                    },
                    {
                        key: 'd3.a1',
                        x: [1065, 1220, 1350],
                        y: [660, 660, 660],
                        type: 'check'
                    },
                    {
                        key: 'd3.a1',
                        x: [1065, 1220, 1350],
                        y: [660, 660, 660],
                        type: 'check'
                    },
                    {
                        key: 'd3.a2',
                        x: [1065, 1220, 1350],
                        y: [685, 685, 685],
                        type: 'check'
                    },
                    {
                        key: 'd3.a3',
                        x: [1065, 1220, 1350],
                        y: [710, 710, 710],
                        type: 'check'
                    },
                    {
                        key: 'd3.b1',
                        x: [1065, 1220, 1350],
                        y: [770, 770, 770],
                        type: 'check'
                    },
                    {
                        key: 'd3.b2',
                        x: [1065, 1220, 1350],
                        y: [795, 795, 795],
                        type: 'check'
                    },
                    {
                        key: 'd3.b3',
                        x: [1065, 1220, 1350],
                        y: [820, 820, 820],
                        type: 'check'
                    },
                    {
                        key: 'd3.b4',
                        x: [1065, 1220, 1350],
                        y: [845, 845, 845],
                        type: 'check'
                    },
                    {
                        key: 'd3.b5',
                        x: [1065, 1220, 1350],
                        y: [870, 870, 870],
                        type: 'check'
                    },
                    {
                        key: 'd3.b6',
                        x: [1065, 1220, 1350],
                        y: [895, 895, 895],
                        type: 'check'
                    },
                    {
                        key: 'd4_1',
                        x: [1065, 1220, 1350],
                        y: [1020, 1020, 1020],
                        type: 'check'
                    },
                    {
                        key: 'd4_2',
                        x: [1065, 1220, 1350],
                        y: [1045, 1045, 1045],
                        type: 'check'
                    },
                    {
                        key: 'd4_3',
                        x: [1065, 1220, 1350],
                        y: [1075, 1075, 1075],
                        type: 'check'
                    },
                    {
                        key: 'd4_4',
                        x: [1065, 1220, 1350],
                        y: [1100, 1100, 1100],
                        type: 'check'
                    },
                    {
                        key: 'd4_5',
                        x: [1065, 1220, 1350],
                        y: [1125, 1125, 1125],
                        type: 'check'
                    },
                    {
                        key: 'd4_6',
                        x: [1065, 1220, 1350],
                        y: [1150, 1150, 1150],
                        type: 'check'
                    },
                    {
                        key: 'd4_7',
                        x: [1065, 1220, 1350],
                        y: [1180, 1180, 1180],
                        type: 'check'
                    },
                    {
                        key: 'd4_8',
                        x: [1065, 1220, 1350],
                        y: [1205, 1205, 1205],
                        type: 'check'
                    },
                    {
                        key: 'd4_9',
                        x: [1065, 1220, 1350],
                        y: [1235, 1235, 1235],
                        type: 'check'
                    },
                    {
                        key: 'd4_10',
                        x: [1065, 1220, 1350],
                        y: [1295, 1295, 1295],
                        type: 'check'
                    },
                    {
                        key: 'd4_11',
                        x: [1065, 1220, 1350],
                        y: [1320, 1320, 1320],
                        type: 'check'
                    },
                    {
                        key: 'd4_12',
                        x: [1065, 1220, 1350],
                        y: [1350, 1350, 1350],
                        type: 'check'
                    },
                    {
                        key: 'd3.note',
                        x: 250,
                        y: 920,
                        maxwidth: 70
                    },
                    {
                        key: 'd3_note', // TODO: da gestire questo piccolo errore
                        x: 250,
                        y: 920,
                        maxwidth: 70
                    }
                ]
            },
            {
                background: 'antincendio',
                show: 'antincendio',
                positions: [
                    {
                        key: 'affilatrice',
                        x: 730,
                        y: 650
                    },
                    {
                        key: 'matricola_2',
                        x: 1180,
                        y: 650
                    },
                    {
                        key: 'customer.agency',
                        x: 325,
                        y: 420
                    },
                    {
                        key: 'customer.address',
                        x: 245,
                        y: 450
                    },
                    {
                        key: 'customer.city',
                        x: 245,
                        y: 475
                    },
                    {
                        key: 'sede.indirizzo',
                        x: 980,
                        y: 450
                    },
                    {
                        key: 'sede.luogo',
                        x: 980,
                        y: 475
                    },
                    {
                        key: 'now',
                        x: 160,
                        y: 1080
                    },
                    {
                        key: 'signature',
                        x: 1140,
                        y: 1040
                    }
                ]
            }
        ]
        Vue.mixin({
            mounted() {
                /**
                 * Ritorna un singolo
                 * @param id
                 * @returns {Promise<unknown>}
                 */
                checksheet.getSingle = (id) => {
                    return new Promise((resolve, reject) => {
                        checksheet.loading = true;
                        let params = {};
                        this.api.get(`/check_sheets/${id}`, params, true)
                            .then((result) => {
                                if (result && result.success) {
                                    resolve(result.data);
                                }
                                reject(null);
                            })
                            .catch(() => {
                                reject(null);
                            })
                            .finally(() => {
                                checksheet.loading = false;
                            });
                    });
                };
                /**
                 * Salvataggio
                 * @param data
                 * @param id
                 * @returns {Promise<unknown>}
                 */
                checksheet.save = (data, id) => {
                    return new Promise((resolve, reject) => {
                        id = (id.toString().toLowerCase().trim() === 'new') ? null : id;
                        let call = null;
                        if (id == null) {
                            call = this.api.post(`/check_sheets`, data, false);
                        } else {
                            call = this.api.put(`/check_sheets/${id}`, data, false);
                        }
                        call.then((result) => {
                            if (result && result.success) {
                                resolve(true);
                            }
                            reject(null);
                        })
                            .catch((error) => {
                                reject(error);
                            });
                    });
                };
                checksheet.delete = (id) => {
                    return new Promise((resolve, reject) => {
                        this.api.delete(`/check_sheets/${id}`, false).then((result) => {
                            if (result && result.success) {
                                resolve(true);
                            }
                            reject(null);
                        })
                            .catch((error) => {
                                reject(error);
                            });
                    });
                }
                /**
                 * Lista degli utenti
                 */
                checksheet.getList = (searchText) => {
                    searchText = searchText || '';
                    checksheet.loading = true;
                    let params = {
                        page: checksheet.page,
                        search: searchText
                    };
                    this.api.get('/check_sheets', params, true)
                        .then((result) => {
                            checksheet.data = [];
                            for (var key in result.data) {
                                checksheet[key] = result.data[key];
                            }
                            checksheet.isFirstList = true;
                            checksheet.isEndList = false;
                            if (checksheet.page !== 1) {
                                checksheet.isFirstList = false;
                                checksheet.isEndList = false;
                            }
                            if (checksheet.page == checksheet.pages) {
                                checksheet.isEndList = true;
                                checksheet.isFirstList = false;
                            }
                        })
                        .finally(() => {
                            checksheet.loading = false;
                        });
                };
                /**
                 * Prende i dati della pagina successiva
                 */
                checksheet.nextPage = () => {
                    if (checksheet.page < checksheet.pages) {
                        checksheet.page = checksheet.page + 1;
                        checksheet.getList();
                    }
                };
                /**
                 * Prende i dati della pagina precendente
                 */
                checksheet.prevPage = () => {
                    if (checksheet.page > 1) {
                        checksheet.page = checksheet.page - 1;
                        checksheet.getList();
                    }
                };
                /**
                 * Prende i dati della prima pagina
                 */
                checksheet.firstPage = () => {
                    checksheet.page = 1;
                    checksheet.getList();
                };
                /**
                 * Prende i dati dell'ultima pagina
                 */
                checksheet.lastPage = () => {
                    checksheet.page = checksheet.pages;
                    checksheet.getList();
                };
                /**
                 * Prende i dati di una pagina prefissata
                 * @param page
                 */
                checksheet.goPage = (page) => {
                    if (page > 0 && page <= checksheet.pages) {
                        checksheet.page = page;
                        checksheet.getList();
                    }
                };
                let offlineMethods = {};
                offlineMethods.buildOfflineData = (page, pageSize, seachText) => {
                    return new Promise(resolve => {
                        let offset = (page - 1) * pageSize;
                        let tmp = {
                            page: page,
                            total: checksheet.dataOff.length,
                            pages: Math.ceil(checksheet.dataOff.length / pageSize),
                            data: _.drop(checksheet.dataOff, offset).slice(0, pageSize)
                        };
                        let result = [];
                        if(tmp.data.length <= 0) {
                            resolve(tmp);
                        }
                        if (checksheet.customers == null || checksheet.customers.length <= 0) {
                            localForage.getItem('customers')
                                .then((customers) => {
                                    checksheet.customers = customers;
                                    tmp.data.map(item => {
                                        let c = _.filter(checksheet.customers, (c) => {
                                            return c.id == item.customer_id;
                                        });
                                        item.customer = {};
                                        if (c && c.length > 0)
                                            item.customer = c.pop();
                                        result.push(item);
                                    });
                                    resolve(tmp);
                                })
                                .catch(() => {
                                    resolve(tmp);
                                });
                        } else {
                            tmp.data.map(item => {
                                let c = _.filter(checksheet.customers, (c) => {
                                    return c.id == item.customer_id;
                                });
                                item.customer = {};
                                if (c && c.length > 0)
                                    item.customer = c.pop();
                                result.push(item);
                            });
                            tmp.data = result;
                            resolve(tmp);
                        }
                    });
                };
                /**
                 * Prende la lista dei clienti offline
                 * @param page
                 * @param pageSize
                 * @param seachText
                 * @returns {Promise<unknown>}
                 */
                offlineMethods.get = (page, pageSize, seachText) => {
                    return new Promise((resolve) => {
                        checksheet.dataOff = [];
                        if (checksheet.dataOff.length <= 0) {
                            // non ci sono dati e quindi li prendo dallo storage la prima volta
                            localForage.getItem('check_sheets')
                                .then((data) => {
                                    data = (data == null) ? [] : data;
                                    data = (data == null) ? [] : data;
                                    data.map(item => {
                                        checksheet.dataOff.push(item);
                                    });
                                    checksheet.dataOff = _.orderBy(checksheet.dataOff, ['updated_at'], ['desc']);
                                    resolve(checksheet.offline.buildOfflineData(page, pageSize, seachText))
                                })
                                .catch(() => {
                                    resolve([]);
                                })
                        } else {
                            resolve(checksheet.offline.buildOfflineData(page, pageSize, seachText))
                        }
                    });
                };
                /**
                 * Inserisce un cliente al database
                 * @param customer
                 * @returns {Promise<unknown>}
                 */
                offlineMethods.add = (customer) => {
                    return new Promise((resolve, reject) => {
                        let customersData = [];
                        localForage.getItem('check_sheets')
                            .then((data) => {
                                data = (data == null) ? [] : data;
                                data.map(item => {
                                    customersData.push(item);
                                });
                                customersData.push(customer);
                                localForage.setItem('check_sheets', customersData, (err) => {
                                    if (err == null) {
                                        resolve(customer.id);
                                    }
                                    reject(err);
                                    checksheet.customers = [];
                                });
                            })
                            .catch((err) => {
                                reject(err)
                            })
                    });
                };
                checksheet.offline = offlineMethods;
            }
        });
        Vue.prototype.api.checksheets = checksheet;
    }
}
